// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import Honeybadger from "@honeybadger-io/js"
import { registerServiceWorker } from "./pwa/registration"

// Browser exceptions go to Honeybadger when the page carries a key. The key
// is printed by layouts/_head.html.erb from HONEYBADGER_JS_API_KEY, which
// is set in production only, so development and test never report; it is
// a browser project key, distinct from the server's HONEYBADGER_API_KEY.
// `revision` is the deploy hash so a report names the build it came from.
const meta = (name) => document.querySelector(`meta[name="${name}"]`)?.content
const honeybadgerKey = meta("honeybadger-api-key")
if (honeybadgerKey) {
  Honeybadger.configure({
    apiKey: honeybadgerKey,
    environment: meta("honeybadger-environment"),
    revision: meta("honeybadger-revision"),
    reportData: true
  })
  // Turbo Drive swaps <body> without reloading, so the surface a report
  // belongs to is re-read on every visit rather than once at boot.
  document.addEventListener("turbo:load", () => {
    Honeybadger.setContext({ surface: document.body.dataset.surface })
  })
}

// The taste app is installable; the other surfaces are plain sites.
if (document.body.dataset.surface === "taste") registerServiceWorker()
